module.exports = __webpack_public_path__ + "static/media/alora-griffiths-TuzrzArccvc-unsplash.ff1547bd.jpg";